// extracted by mini-css-extract-plugin
module.exports = {"Component":"Faq_Component__3qmn_","Text_center":"Faq_Text_center__tbdUX","Content":"Faq_Content__2cF8j"};